import { render } from "./PlanosVinculados.vue?vue&type=template&id=54acae1c&scoped=true"
import script from "./PlanosVinculados.vue?vue&type=script&lang=js"
export * from "./PlanosVinculados.vue?vue&type=script&lang=js"

import "./PlanosVinculados.vue?vue&type=style&index=0&id=54acae1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54acae1c"]])

export default __exports__